import { render } from "./BoostedChart.vue?vue&type=template&id=673604f2"
import script from "./BoostedChart.vue?vue&type=script&lang=js"
export * from "./BoostedChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__